import React, { useContext, useEffect, useState } from "react";
import { getLocalStorage, setLocalStorage } from "utils/storageUtil";

const NavContext = React.createContext();

export const AccessbilityViewHeight = "40vh";

const NavProvider = (props) => {
  const [showHeader, setShowHeader] = useState(true);
  const [accessibilityMode, setAccessibilityMode] = useState(false);
  const [isKeyboardOpen, setIsKeyboardOpen] = useState(false);

  const [excludedInActivityRoutes, setExcludedInActivityRoutes] = useState([
    "/",
  ]);

  useEffect(() => {
    const accessibilityModeSetting = getLocalStorage("accessibilityMode");
    if (accessibilityModeSetting) {
      setAccessibilityMode(accessibilityModeSetting === true);
    }
  }, []);

  useEffect(() => {
    setLocalStorage("accessibilityMode", accessibilityMode);
  }, [accessibilityMode]);

  const toggleAccessibilityMode = () => {
    setAccessibilityMode((prevMode) => {
      setLocalStorage("accessibilityMode", !prevMode);
      return !prevMode;
    });
  };

  return (
    <NavContext.Provider
      value={{
        showHeader,
        setShowHeader,
        accessibilityMode,
        setAccessibilityMode,
        toggleAccessibilityMode,
        excludedInActivityRoutes,
        setExcludedInActivityRoutes,
        setIsKeyboardOpen,
        isKeyboardOpen,
      }}
    >
      {props.children}
    </NavContext.Provider>
  );
};

export { NavContext, NavProvider };

export const useNav = () => {
  return useContext(NavContext);
};
